import { useMutation, useQueryClient } from '@tanstack/react-query';
import { communityQueryKeys } from '../constants';
import { toast } from 'react-hot-toast';
import {
  AddReplyDocument,
  AddReplyMutationVariables,
  GetCommunityPostDocument,
  Reply,
} from '../../../../generated/graphql';
import { apolloClient } from '@client/api/graphql/client';
import { RefetchQueryDescriptor } from '@apollo/client/core/types';

type AddReplyPayload = {
  text: string;
};

export const useAddReplyMutation = (communityId: number, postId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload: AddReplyPayload) => {
      return apolloClient.mutate<Reply, AddReplyMutationVariables>({
        mutation: AddReplyDocument,
        variables: {
          text: payload.text,
          communityId,
          postId,
        },
      });
    },
    {
      onSuccess: () => {
        toast.success('Reply added successfully!');
      },
      onError: async (error: Error) => {
        console.error({ error });
        toast.error('Something went wrong');
      },
      onSettled: async () => {
        await queryClient.refetchQueries(
          communityQueryKeys.post(communityId, postId),
        );
      },
    },
  );
};
